// extracted by mini-css-extract-plugin
module.exports = {"container":"cardListInStore_container__oPL0Y","content":"cardListInStore_content__E9k9K","text":"cardListInStore_text__XQEWO"};